import { deserializeAllMethodsIn, serializeAllMethodsIn } from './serialization';
import { wrap, expose, releaseProxy } from 'comlink';
export const handshakeCode = 'wix-sdk-bo-hello-handshake';
/**
 * Initializes a new channel with a target.
 * @param postMessage - Target's function to receive messages.
 * @param origin - Target's origin.
 */
export const open = _ref => {
  let {
    postMessage,
    origin
  } = _ref;
  const {
    port1: widgetPort,
    port2: hostPort
  } = new MessageChannel();
  const protocolVersion = '1.0.0';
  const message = {
    code: handshakeCode,
    version: protocolVersion,
    port: hostPort
  };
  postMessage(message, origin, [hostPort]);
  const channel = serializeAllMethodsIn(wrap(widgetPort));
  return {
    channel,
    close: () => channel[releaseProxy]()
  };
};

/**
 * Serves api as a response over the communication channel to given port.
 * @param api - The api object that has the methods inside it.
 * @param port - The port on which the channel was initiated and needs to receive the api.
 */
export const serve = _ref2 => {
  let {
    api,
    port
  } = _ref2;
  expose(deserializeAllMethodsIn(api), port);
};
//# sourceMappingURL=index.js.map